import { Stack, type SxProps, type Theme } from "@mui/material";
import { type ReactNode } from "react";

import { Text } from "../../components/Text";

interface LabeledFieldProps {
  label: string;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Label-above-control layout shared by the Add Shift panel's form fields.
 */
export function LabeledField(props: LabeledFieldProps) {
  const { label, children, sx } = props;

  return (
    <Stack spacing={2} sx={sx}>
      <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
        {label}
      </Text>
      {children}
    </Stack>
  );
}
